import { Session, User } from '@paragon/contract-library';
import { ServerConnection } from '@paragon/data-connections';

const AuthorizationServer = new ServerConnection('authorizationApiUrl');

interface AuthenticationResponse {
  readonly token: string;
  readonly user: User;
}

export function pAuthenticateUser(email: string, password: string): Promise<AuthenticationResponse> {
  return AuthorizationServer.post('tokens', { data: { email, password } });
}

export function pGenerateResetCode(email: string) {
  return AuthorizationServer.post(`users/${email}/resetCode`);
}

interface ResetCodeResponse {
  readonly code: number;
  readonly valid: boolean;
}

export async function pIsResetCodeValid(email: string, code: string): Promise<boolean> {
  const response = await AuthorizationServer.get<ResetCodeResponse>(`users/${email}/resetCode/${code}`);
  return response.valid;
}

export function pUseResetCodeToSetPassword(email: string, resetCode: string, password: string) {
  return AuthorizationServer.post(`users/${email}/resetPassword`, {
    data: {
      resetCode,
      password,
    },
  });
}

export function pValidateGuids(organizationGuid: string, customerGuid: string): Promise<AuthenticationResponse> {
  return AuthorizationServer.get(`loginWithLinkGuid/${organizationGuid}/${customerGuid}`);
}

export function pValidateToken(token: string): Promise<User> {
  return AuthorizationServer.get(`tokens/${token}`);
}

export function pGetCurrentSession(): Promise<Session | null> {
  return AuthorizationServer.get('session');
}
